const counters = document.querySelectorAll('.facts_and_numbers__number span');
const duration = 2000; // 2 seconds
const frameDuration = 16.67; // 16.67ms per frame for 60fps

// Function to update the counter value
const updateCount = (counter) => {
	const target = parseInt(counter.getAttribute('data-target').replace(/[.,]/g, ''));
	const current = parseInt(counter.innerText.replace(/[^0-9.-]+/g, '')) || 0;
	const increment = Math.ceil(target / (duration / frameDuration));

	if (current < target) {
		counter.innerText = current + increment;
		requestAnimationFrame(() => updateCount(counter));
	} else {
		counter.innerText = counter.getAttribute('data-target');
	}
};

// IntersectionObserver callback function
const handleIntersection = (entries, observer) => {
	entries.forEach(entry => {
		if (entry.isIntersecting) {
			const counter = entry.target;
			counter.innerText = '0';
			updateCount(counter);
			observer.unobserve(counter); // Stop observing once the animation starts
		}
	});
};

// Create an IntersectionObserver instance
const observer = new IntersectionObserver(handleIntersection, { threshold: 0.1 });

// Observe each counter element
counters.forEach(counter => {
	observer.observe(counter);
});